import { isEqual, isUndefined, omitBy } from 'lodash-es'

export type NewObject = { [key: string]: unknown }

export type Nullable<T> = {
  [K in keyof T]: T[K] | null
}

export const isEqualExceptUndefined = <T extends NewObject>(
  obj1: T,
  obj2: T,
) => {
  const cleanUndefined = (obj: T) => omitBy(obj, isUndefined)

  const cleanedObj1 = cleanUndefined(obj1)
  const cleanedObj2 = cleanUndefined(obj2)

  return isEqual(cleanedObj1, cleanedObj2)
}
